var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",class:{hideSidebar:!!_vm.$store.state.hidesidebar}},[_c('silder'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('nav-bar'),_vm._v(" "),_c('div',{staticClass:"main"},[_c('content-box')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-fdb46cac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/layer.vue
// module id = 4dR1
// module chunks = 11